import {Directive, ElementRef, Input, OnDestroy, OnInit} from '@angular/core';
import {Project} from "../models/project";
import {Subscription} from "rxjs";
import {AuthenticationService} from "../services/authentication.service";

@Directive({
  selector: '[appProjectAdminAccess]',
  standalone: true
})
export class ProjectAdminAccessDirective implements OnInit {
  @Input() project!: Project;

  constructor(private elementRef: ElementRef, private authenticationService: AuthenticationService) { }

  ngOnInit() {
    const result = this.authenticationService.isProjectAdmin(this.project);
    this.setHidden(!result);
  }

  private setHidden(value: boolean) {
    this.elementRef.nativeElement.hidden = value;
  }
}
